export default __webpack_public_path__ + "static/media/ThaiSansNeue-ExtraBold.50fe9293.ttf";